  // coffeelint: disable
angular.module('gym.user', ['model']).factory('User', [
  'Model',
  function(Model) {
    var FormDataFactory,
  User;
    FormDataFactory = function(form) {
      var FormData;
      return FormData = (function() {
        class FormData extends Model {
          toParam() {
            var index, param;
            if (!(param = this.get('id'))) {
              param = 'new';
              if (this.collection() && ((index = this.collection().indexOf(this)) != null)) {
                param += `:${index}`;
              }
            }
            return param;
          }

          get(attr) {
            // TODO: type coercion
            return this.attributes[attr];
          }

          set(attr, val) {
            // TODO: type coercion
            return this.attributes[attr] = val;
          }

        };

        FormData.param = form.name;

        return FormData;

      }).call(this);
    };
    return User = (function() {
      class User extends Model {
        initialize(...args) {
          super.initialize(...args);
          return this.gym().forms().each((form) => {
            var base, base1, name1, name2;
            if (form.isCollection()) {
              return (base = this.attributes)[name1 = form.attributes.name] || (base[name1] = []);
            } else {
              return (base1 = this.attributes)[name2 = form.attributes.name] || (base1[name2] = {});
            }
          });
        }

        name() {
          return [this.fieldValue('first_name'), this.fieldValue('last_name')].join(' ');
        }

        email() {
          return this.fieldValue('email');
        }

        get(form) {
          var data;
          if (!_.isObject(form)) {
            form = this.gym().forms().where({
              name: name
            });
          }
          if (!form) {
            throw `Unknown form ${form}`;
          }
          data = this.attributes[form.name()];
          if ((data != null ? data._model : void 0) != null) {
            return data._model;
          }
          if (form.isCollection()) {
            return this.wrap(form.name(), FormDataFactory(form))();
          } else {
            return (this._wraps || (this._wraps = {}))[form.name()] = new (FormDataFactory(form))(data, {
              parent: this
            }, true);
          }
        }

        fieldValue(name) {
          var form;
          form = this.formWithField(name);
          if (form) {
            return form.get(name);
          } else {
            return null;
          }
        }

        formWithField(name) {
          return this.get(this.gym().formWithField(name));
        }

      };

      User.param = 'user';

      User.prototype.gym = User.prototype.parent;

      return User;

    }).call(this);
  }
]);

// coffeelint: enable
